import React, { useState } from 'react';
import { MdCheckCircle, MdCancel, MdAccessTime } from 'react-icons/md';
import Modal from '../../ui/Modal';
import { Button } from '../../ui/PageShell';
import useDirtyForm from '../useDirtyForm';

const ACTIONS = {
  present: { title: 'تحضير', Icon: MdCheckCircle, tone: 'success' },
  absent: { title: 'تعيين كغائب', Icon: MdCancel, tone: 'danger' },
  late: { title: 'تعيين كمتأخر', Icon: MdAccessTime, tone: 'warning' },
};

const STATUS_LABEL = { present: 'حاضر', absent: 'غائب', late: 'متأخر' };

/**
 * Correct one pupil's attendance for one day, after the register was
 * taken. Mirrors the old AttendanceActionModal: a note is REQUIRED
 * whenever the status actually changes (the API enforces the same rule,
 * [R38]) and optional when re-confirming the status it already has.
 */
export default function AttendanceActionModal({ record, action, onConfirm, onCancel, busy }) {
  const [note, setNote] = useState(record?.note || '');
  const dirty = useDirtyForm(note);
  const cfg = ACTIONS[action] || ACTIONS.present;
  const isChanging = record?.status !== action;

  const submit = (e) => {
    e.preventDefault();
    if (isChanging && !note.trim()) return; // button is disabled too
    onConfirm(action, note.trim());
  };

  return (
    <Modal
      open
      size="sm"
      title={
        <span className={`aam-title is-${cfg.tone}`}>
          <cfg.Icon size={22} /> {cfg.title}
        </span>
      }
      onClose={busy ? undefined : onCancel}
      confirmClose={!busy && dirty.isDirty}
      footer={(requestClose) => (
        <>
          <Button variant="secondary" onClick={requestClose} disabled={busy}>إلغاء</Button>
          <Button
            variant={cfg.tone}
            onClick={submit}
            disabled={isChanging && !note.trim()}
            loading={busy}
          >
            تأكيد {cfg.title}
          </Button>
        </>
      )}
    >
      <div className="aam-info">
        <div className="aam-row"><span>الطالب:</span><b>{record.student_name}</b></div>
        <div className="aam-row"><span>التاريخ:</span><b>{record.date}</b></div>
        <div className="aam-row">
          <span>الحالة الحالية:</span>
          <b className={`aam-chip is-${record.status}`}>{STATUS_LABEL[record.status]}</b>
        </div>
      </div>

      <form onSubmit={submit} className="aam-form">
        <label className="aam-label">
          ملاحظة {isChanging && <span className="aam-required">*</span>}
        </label>
        <textarea
          className="ui-input ui-textarea"
          rows={3}
          autoFocus
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder={isChanging
            ? 'الملاحظة مطلوبة عند تغيير حالة الحضور...'
            : 'أضف ملاحظة حول حالة الحضور (اختياري)...'}
          disabled={busy}
        />
        {isChanging && (
          <span className="aam-hint">* يجب إضافة ملاحظة عند تغيير حالة الحضور</span>
        )}
      </form>
    </Modal>
  );
}
